import React from 'react';
import {
  withRouter,
  useHistory,
} from 'react-router-dom';
import {
  Link,
  Grid,
  Typography,
} from '@material-ui/core';

import translations from '../../languages/i18n';
import { noMatch } from '../../styles/formElementsStyles';

function AccessDenied({showContent}) {
  const history = useHistory();
  const noMatchStyle = noMatch();

  return (
    <div className={noMatchStyle.content}>
      {showContent && (
        <Grid container direction='row' spacing={2} alignItems='center' justify='center'>
          <Grid item>
            <img src={require('../../assets/images/logoHT.png')} alt='HT Logo' width='150' heigth='150' />
          </Grid>
          <Grid item>
            <Typography component='h1' variant='h4'>{translations['_accessDenied']}</Typography>
            <Link href='#' variant='body1' onClick={() => history.push('/')}>{translations['_noMatchBack']}</Link>
          </Grid>
        </Grid>
        )}
    </div>
  );
}

export default withRouter(AccessDenied);
